@if (showMobileMenu() && showHeader()) {
  <!-- Mobile backdrop -->
  <div
    class="fixed inset-0 z-40 bg-black/30 backdrop-blur-[1px]"
    aria-hidden="true"
    (click)="showMobileMenu.set(false)">
  </div>

  <!-- Mobile navigation -->
  <nav
    id="mobile-nav-menu"
    aria-label="Mobile navigation"
    class="fixed right-3 top-16 z-50 max-h-[calc(100vh-5rem)] min-w-56 overflow-y-auto rounded-xl border border-base-100/10
           bg-linear-to-br from-base-300/80 via-base-300/90 to-base-300 shadow-xl backdrop-blur-xl">

    <div class="flex flex-col p-2">
      @if (authenticated()) {
        <app-nav-item
          routerLink="home"
          icon="home"
          label="Home"
          (click)="showMobileMenu.set(false)" />
      }

      <app-nav-item
        routerLink="discover"
        icon="dashboard_customize"
        label="Discover"
        (click)="showMobileMenu.set(false)" />

      @if (isReader() || isContributor() || isHealthGuardUser()) {
        <div class="mx-2 my-2 h-px bg-base-content/10"></div>
      }

      @if (isReader()) {
        <app-nav-item
          routerLink="service-tooling"
          icon="table_chart_view"
          label="Service Tooling"
          (click)="showMobileMenu.set(false)" />
      }

      @if (isContributor()) {
        <app-nav-item
          routerLink="admin"
          icon="admin_panel_settings"
          label="Admin Center"
          (click)="showMobileMenu.set(false)" />

        <app-nav-item
          routerLink="bluecreek"
          icon="analytics"
          label="BlueCreek"
          (click)="showMobileMenu.set(false)" />
      }

      @if (isHealthGuardUser()) {
        <app-nav-item
          routerLink="health-guard"
          icon="shield_with_heart"
          label="Health Guard"
          (click)="showMobileMenu.set(false)" />
      }

      <div class="mx-2 my-2 h-px bg-base-content/10"></div>

      @if (authenticated()) {
        <app-nav-item
          type="button"
          icon="logout"
          label="Sign out"
          (click)="confirmDialogOpen.set(true); showMobileMenu.set(false)" />
      } @else {
        <app-nav-item
          routerLink="login"
          icon="login"
          label="Sign in"
          (click)="showMobileMenu.set(false)" />
      }
    </div>
  </nav>
}

@if (showHeader()) {
  <!-- Mobile header -->
  <header
    aria-label="Site header"
    class="fixed inset-x-0 top-0 z-50 flex h-12 items-center border-b border-base-100/5 bg-base-300/95 px-4 backdrop-blur-xl">

    <div class="flex w-full items-center justify-between">
      <a
        [routerLink]="authenticated() ? 'home' : 'login'"
        aria-label="Go to home"
        class="flex items-center">
        <img
          src="../../../../assets/images/blueocean_logo_small.png"
          alt="BlueOcean logo"
          class="h-6" />
      </a>

      <button
        type="button"
        aria-label="Toggle navigation menu"
        aria-controls="mobile-nav-menu"
        [attr.aria-expanded]="showMobileMenu()"
        class="flex size-9 items-center justify-center rounded-lg text-base-100 transition-colors hover:bg-base-100/5
               focus-visible:outline-2 focus-visible:outline-primary"
        (click)="showMobileMenu.set(!showMobileMenu())">

        <span class="material-symbols-outlined" aria-hidden="true">
          {{ showMobileMenu() ? 'close' : 'menu' }}
        </span>
      </button>
    </div>
  </header>
}

@if (!showHeader()) {
  <!-- Desktop sidebar -->
  <aside
    aria-label="Primary navigation"
    class="fixed inset-y-0 left-0 z-40 flex flex-col overflow-hidden border-r border-base-100/5
           bg-linear-to-b from-base-300/70 via-base-300/80 to-base-300 text-xs text-base-content
           backdrop-blur-xl transition-[width] duration-300 motion-reduce:transition-none"
    [class.w-64]="!collapsed()"
    [class.w-20]="collapsed()">

    <!-- Brand -->
    <div
      class="flex shrink-0 items-center px-4 py-3.5"
      [class.justify-center]="collapsed()">

      <a
        [routerLink]="authenticated() ? 'home' : 'login'"
        aria-label="Go to home"
        class="flex items-center">

        <img
          [src]="collapsed()
            ? '../../../../assets/images/blueocean_logo_small.png'
            : '../../../../assets/images/blueocean_cegeka_product.png'"
          alt="BlueOcean logo"
          class="transition-all duration-300 motion-reduce:transition-none"
          [class.h-14]="!collapsed()"
          [class.h-5]="collapsed()" />
      </a>
    </div>

    <div class="mx-2 h-px shrink-0 bg-base-content/10"></div>

    <!-- Main navigation -->
    <div class="flex shrink-0 flex-col py-2">
      @if (authenticated()) {
        <app-nav-item
          [collapsed]="collapsed()"
          routerLink="home"
          icon="home"
          label="Home" />
      }

      <app-nav-item
        [collapsed]="collapsed()"
        routerLink="discover"
        icon="dashboard_customize"
        label="Discover" />

      @if (isReader()) {
        <app-nav-item
          [collapsed]="collapsed()"
          routerLink="service-tooling"
          icon="table_chart_view"
          label="Service Tooling" />
      }

      @if (isContributor()) {
        <app-nav-item
          [collapsed]="collapsed()"
          routerLink="admin"
          icon="admin_panel_settings"
          label="Admin Center" />

        <app-nav-item
          [collapsed]="collapsed()"
          routerLink="bluecreek"
          icon="analytics"
          label="BlueCreek" />
      }

      @if (isHealthGuardUser()) {
        <app-nav-item
          [collapsed]="collapsed()"
          routerLink="health-guard"
          icon="shield_with_heart"
          label="Health Guard" />
      }
    </div>

    <div class="mx-2 h-px shrink-0 bg-base-content/10"></div>

    <!-- Report navigation -->
    @if (route().startsWith('/report')) {
      <div class="min-h-0 flex-1 overflow-y-auto py-2">
        <app-reports-icon-list />
      </div>
    } @else {
      <div class="flex-1"></div>
    }

    <!-- Bottom actions -->
    <div class="shrink-0">
      <div class="mx-2 h-px bg-base-content/10"></div>

      @if (authenticated()) {
        <app-nav-item
          type="button"
          [collapsed]="collapsed()"
          icon="logout"
          label="Sign out"
          (click)="confirmDialogOpen.set(true)" />
      } @else {
        <app-nav-item
          [collapsed]="collapsed()"
          routerLink="login"
          icon="login"
          label="Sign in" />
      }

      @if (authenticated()) {
        <div class="mx-3 h-px bg-base-content/10"></div>

        <div class="pb-2">
          <app-user-profile-nav-item [collapsed]="collapsed()" />
        </div>
      }
    </div>
  </aside>
}

<app-confirm-dialog
  [dialogOpen]="confirmDialogOpen()"
  action="sign out"
  (confirm)="logout()"
  (cancel)="confirmDialogOpen.set(false)">
</app-confirm-dialog>